/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1097
 */

var r = require(/* 246 */"../1782/246/index")("match")
module.exports = function (e) {
  var t = /./
  try {
    "/./"[e](t)
  } catch (n) {
    try {
      t[r] = false
      return "/./"[e](t)
    } catch (o) {}
  }
  return false
}
